module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hZIxW"))).then(() => parcelRequire('hEqeo'));